import { Col } from "antd";
import useWindowSize from "../Hooks/windowSize";
import { columnWidth, interviews } from "../../assets/text/interview";

const InterviewDetail = ({ handleImageLink }) => {
  const [width, height] = useWindowSize();
  return (
    <div className="interview-detail">
      <div className="interview-detail-name">
        <div className="interview-detail-name-english">interviews</div>
        <div className="interview-detail-name-arabic">مقابلات</div>
      </div>
      <div
        className="interview-detail-gallery"
        style={{ height: width > 320 && width < 768 ? "100vh" : height - 214 }}
      >
        {columnWidth.map((columnItem, columnIndex) => {
          return (
            <Col
              className="interview-detail-gallery-col"
              style={{ marginLeft: "1.7%", width: columnItem }}
            >
              {interviews.map((item, index) => {
                return item.column === columnIndex + 1 ? (
                  <div
                    className="interview-detail-gallery-wrapper"
                    onClick={() => handleImageLink(true, item.content)}
                  >
                    <img
                      src={`/images/${item.image}`}
                      className="interview-detail-gallery-wrapper-image"
                      alt="Interview"
                    ></img>
                    <div
                      className={
                        "interview-detail-gallery-wrapper-gradientoverlay"
                      }
                    ></div>
                    <div
                      className={
                        item.overlay === "red"
                          ? "interview-detail-gallery-wrapper-redoverlay"
                          : "interview-detail-gallery-wrapper-overlay"
                      }
                    ></div>
                    <div
                      className={"interview-detail-gallery-wrapper-title"}
                      style={{
                        color: item.textColor === "black" ? "#000" : "#fff",
                      }}
                    >
                      <span className="interview-detail-gallery-wrapper-title-interarabic">
                        مقابلة مع
                      </span>
                      <span className="interview-detail-gallery-wrapper-title-arabic">
                        {item.content.arabic.interviewee}
                      </span>
                      <span className="interview-detail-gallery-wrapper-title-intereng">
                        Interview with
                      </span>
                      <span className="interview-detail-gallery-wrapper-title-eng">
                        {item.content.english.interviewee}
                      </span>
                    </div>
                    <div
                      className={"interview-detail-gallery-wrapper-text"}
                      style={{
                        color: item.textColor === "black" ? "#000" : "#fff",
                      }}
                    >
                      <span className="interview-detail-gallery-wrapper-text-date">
                        {item.dateNumeral}
                      </span>
                      <span className="interview-detail-gallery-wrapper-text-arabic">
                        {item.content.arabic.title}
                      </span>
                      <span className="interview-detail-gallery-wrapper-text-eng">
                        {item.content.english.title}
                      </span>
                    </div>
                  </div>
                ) : null;
              })}
            </Col>
          );
        })}
      </div>
    </div>
  );
};

export default InterviewDetail;
